"use client";

import { useBreakpoint } from "@/shared/hooks/use-breakpoint";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/ui/tabs";
import { useTranslations } from "next-intl";
import { useQueryState } from "nuqs";

const MDS_ANALYSIS_LIST = [
  {
    id: 1,
    title: "f_isd_cat_1_title_1",
    description: "f_isd_cat_1_context_1",
    img: "/images/solution/MDS_1_01.webp",
  },
  {
    id: 2,
    title: "f_isd_cat_1_title_2",
    description: "f_isd_cat_1_context_2",
    img: "/images/solution/MDS_1_02.webp",
  },
  {
    id: 3,
    title: "f_isd_cat_1_title_3",
    description: "f_isd_cat_1_context_3",
    img: "/images/solution/MDS_1_03.webp",
  },
  {
    id: 4,
    title: "f_isd_cat_1_title_4",
    description: "f_isd_cat_1_context_4",
    img: "/images/solution/MDS_1_04.webp",
  },
  {
    id: 5,
    title: "f_isd_cat_1_title_5",
    description: "f_isd_cat_1_context_5",
    img: "/images/solution/MDS_1_05.webp",
  },
  {
    id: 6,
    title: "f_isd_cat_1_title_6",
    description: "f_isd_cat_1_context_6",
    img: "/images/solution/MDS_1_06.webp",
  },
  {
    id: 7,
    title: "f_isd_cat_1_title_7",
    description: "f_isd_cat_1_context_7",
    img: "/images/solution/MDS_1_07.webp",
  },
  {
    id: 8,
    title: "f_isd_cat_1_title_8",
    description: "f_isd_cat_1_context_8",
    img: "/images/solution/MDS_1_08.webp",
  },
];

const MPS_ANALYSIS_LIST = [
  {
    id: 1,
    title: "f_isp_cat_1_title_1",
    description: "f_isp_cat_1_context_1",
    img: "/images/solution/MPS_1_01.webp",
  },
  {
    id: 2,
    title: "f_isp_cat_1_title_2",
    description: "f_isp_cat_1_context_2",
    img: "/images/solution/MPS_1_02.webp",
  },
  {
    id: 3,
    title: "f_isp_cat_1_title_3",
    description: "f_isp_cat_1_context_3",
    img: "/images/solution/MPS_1_03.webp",
  },
  {
    id: 4,
    title: "f_isp_cat_1_title_4",
    description: "f_isp_cat_1_context_4",
    img: "/images/solution/MPS_1_04.webp",
  },
  {
    id: 5,
    title: "f_isp_cat_1_title_5",
    description: "f_isp_cat_1_context_5",
    img: "/images/solution/MPS_1_05.webp",
  },
  {
    id: 6,
    title: "f_isp_cat_1_title_6",
    description: "f_isp_cat_1_context_6",
    img: "/images/solution/MPS_1_06.webp",
  },
  {
    id: 7,
    title: "f_isp_cat_1_title_7",
    description: "f_isp_cat_1_context_7",
    img: "/images/solution/MPS_1_07.webp",
  },
  {
    id: 8,
    title: "f_isp_cat_1_title_8",
    description: "f_isp_cat_1_context_8",
    img: "/images/solution/MPS_1_08.webp",
  },
  {
    id: 9,
    title: "f_isp_cat_1_title_9",
    description: "f_isp_cat_1_context_9",
    img: "/images/solution/MPS_1_09.webp",
  },
  {
    id: 10,
    title: "f_isp_cat_1_title_10",
    description: "f_isp_cat_1_context_10",
    img: "/images/solution/MPS_1_10.webp",
  },
  {
    id: 11,
    title: "f_isp_cat_1_title_11",
    description: "f_isp_cat_1_context_11",
    img: "/images/solution/MPS_1_11.webp",
  },
];

const MPS_PROCEDURE_LIST = [
  {
    id: 1,
    title: "f_isp_cat_2_title_1",
    description: "f_isp_cat_2_context_1",
    img: "/images/solution/MPS_2_01.webp",
  },
  {
    id: 2,
    title: "f_isp_cat_2_title_2",
    description: "f_isp_cat_2_context_2",
    img: "/images/solution/MPS_2_02.webp",
  },
  {
    id: 3,
    title: "f_isp_cat_2_title_3",
    description: "f_isp_cat_2_context_3",
    img: "/images/solution/MPS_2_03.webp",
  },
  {
    id: 4,
    title: "f_isp_cat_2_title_4",
    description: "f_isp_cat_2_context_4",
    img: "/images/solution/MPS_2_04.webp",
  },
  {
    id: 5,
    title: "f_isp_cat_2_title_5",
    description: "f_isp_cat_2_context_5",
    img: "/images/solution/MPS_2_05.webp",
  },
  {
    id: 6,
    title: "f_isp_cat_2_title_6",
    description: "f_isp_cat_2_context_6",
    img: "/images/solution/MPS_2_06.webp",
  },
];

export default function SolutionPage() {
  const t = useTranslations();
  const { isMobile } = useBreakpoint();
  const [tab, setTab] = useQueryState("tab", { defaultValue: "mps" });

  return (
    <div className="tb:pt-20 pc:pb-40 tb:pb-30 flex flex-col items-center pt-12 pb-20">
      <div className="pc:mt-[94px] tb:mt-[80px] mt-[60px] w-full max-w-[1280px]">
        <div className="pc:px-0 tb:px-10 tb:mb-10 mb-5 flex w-full px-4">
          <h1 className="heading-1 text-gray-900">{t("f_isp_title")}</h1>
        </div>
      </div>
      <div className="w-full">
        <Tabs value={tab} onValueChange={setTab} className="w-full items-center gap-0">
          <div className="tb:mb-20 mb-15 flex w-full items-center justify-center border-b border-gray-100">
            <TabsList className="h-full w-full max-w-[1280px] p-0">
              <TabsTrigger
                className="body-xl-medium tb:py-7 rounded-none bg-white p-0 py-3 data-[state=active]:border-b-2 data-[state=active]:border-gray-900 data-[state=active]:bg-white data-[state=active]:font-bold data-[state=active]:text-gray-900"
                value="mps"
              >
                {isMobile ? "MPS" : t("mn_mi_tab_mps")}
              </TabsTrigger>
              <TabsTrigger
                className="body-xl-medium tb:py-7 rounded-none bg-white p-0 py-3 data-[state=active]:border-b-2 data-[state=active]:border-gray-900 data-[state=active]:bg-white data-[state=active]:font-bold data-[state=active]:text-gray-900"
                value="mds"
              >
                {isMobile ? "MDS" : t("mn_mi_tab_mds")}
              </TabsTrigger>
            </TabsList>
          </div>
          <TabsContent value="mps" className="pc:px-4 tb:px-10 w-full max-w-[1280px] px-4">
            <div className="bg-secondary-100 tb:p-10 pc:flex-row tb:mb-20 pc:gap-15 tb:gap-8 mb-10 flex w-full flex-col items-center gap-5 rounded-[16px] p-6">
              <div className="w-[331px] flex-shrink-0 text-center">
                <h2 className="heading-2 text-primary-500">{t("f_isp_mps_title_1")}</h2>
                <h3 className="heading-3-regular whitespace-nowrap text-gray-900">{t("f_isp_mps_title_2")}</h3>
              </div>

              <p className="body-lg-regular whitespace-pre-line text-gray-700">{t("f_isp_mps_context")}</p>
            </div>

            <div>
              <h3 className="heading-3-bold tb:mb-10 mb-5 text-gray-900">{t("f_isp_cat_1")}</h3>

              <div className="pc:grid-cols-3 pc:gap-x-5 pc:gap-y-8 tb:gap-x-4 tb:gap-y-8 grid grid-cols-2 gap-x-2 gap-y-6">
                {MPS_ANALYSIS_LIST.map((item) => (
                  <div key={item.id}>
                    <div className="tb:rounded-t-24 tb:p-7.5 tb:h-90 rounded-t-[10px] bg-black p-3">
                      <img src={item.img} alt={t(item.title)} className="h-full w-full object-cover" />
                    </div>
                    <div className="tb:rounded-b-24 tb:p-7.5 tb:gap-3 pc:gap-4 tb:h-45 flex h-[250px] flex-col gap-1 rounded-b-[10px] border border-t-0 border-gray-100 bg-white p-[14px] pb-5">
                      <span className="body-xl-bold text-gray-900">{t(item.title)}</span>
                      <span className="body-md-regular break-words whitespace-pre-line text-gray-500">
                        {t(item.description)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="tb:my-20 my-10 h-[1px] w-full bg-gray-100" />

              <h3 className="heading-3-bold tb:mb-10 mb-5 text-gray-900">{t("f_isp_cat_2")}</h3>

              <div className="pc:grid-cols-3 pc:gap-x-5 pc:gap-y-8 tb:gap-x-4 tb:gap-y-8 grid grid-cols-2 gap-x-2 gap-y-6">
                {MPS_PROCEDURE_LIST.map((item) => (
                  <div key={item.id}>
                    <div className="tb:rounded-t-24 tb:p-7.5 tb:h-90 rounded-t-[10px] bg-black p-3">
                      <img src={item.img} alt={t(item.title)} className="h-full w-full object-cover" />
                    </div>
                    <div className="tb:rounded-b-24 tb:p-7.5 tb:gap-3 pc:gap-4 tb:h-45 flex h-[250px] flex-col gap-1 rounded-b-[10px] border border-t-0 border-gray-100 bg-white p-[14px] pb-5">
                      <span className="body-xl-bold text-gray-900">{t(item.title)}</span>
                      <span className="body-md-regular whitespace-pre-line text-gray-500">{t(item.description)}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </TabsContent>
          <TabsContent value="mds" className="pc:px-4 tb:px-10 w-full max-w-[1280px] px-4">
            <div className="bg-secondary-100 tb:p-10 pc:flex-row tb:mb-20 pc:gap-15 tb:gap-8 mb-10 flex w-full flex-col items-center gap-5 rounded-[16px] p-6">
              <div className="w-[331px] flex-shrink-0 text-center">
                <h2 className="heading-2 text-primary-500">{t("f_isd_mps_title_1")}</h2>
                <h3 className="heading-3-regular whitespace-nowrap text-gray-900">{t("f_isd_mps_title_2")}</h3>
              </div>

              <p className="body-lg-regular whitespace-pre-line text-gray-700">{t("f_isd_mps_context")}</p>
            </div>

            <div>
              <div className="pc:grid-cols-2 pc:gap-x-5 pc:gap-y-8 tb:gap-y-8 grid grid-cols-1 gap-y-6">
                {MDS_ANALYSIS_LIST.map((item) => (
                  <div key={item.id}>
                    <div className="tb:rounded-t-24 tb:p-7.5 tb:h-90 rounded-t-[10px] bg-black p-[15px]">
                      <img src={item.img} alt={t(item.title)} className="h-full w-full object-cover" />
                    </div>
                    <div className="tb:rounded-b-24 pc:h-[178px] tb:p-7.5 tb:gap-3 pc:gap-4 flex h-[180px] flex-col gap-1 rounded-b-[10px] border border-t-0 border-gray-100 bg-white p-[14px] pb-5">
                      <span className="body-xl-bold text-gray-900">{t(item.title)}</span>
                      <span className="body-md-regular whitespace-pre-line text-gray-500">{t(item.description)}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
